/**
 * @ngdoc service
 * @name common.service:ItxPhoneSvc
 * @requires $q
 * @description
 * Phone verification service
 */
(function() {
    'use strict';

    angular.module('itxApp.common')
        .factory('ItxPhoneSvc', ItxPhoneSvc);

    ItxPhoneSvc.$inject = ['$q'];

    function ItxPhoneSvc($q) {

        var _this = this;


        inditex.onReady(function () {
            inditex.getXconfiguracionValue('ENABLE_PHONE_VALIDATION', function(status, value) {
                _this.isEnabled = (value == '1');
            });
        });

        return {
            sendSMS: sendSMS,
            updateUserPhone: updateUserPhone,
            validateGuestPhone: validateGuestPhone,
            updateUserLogon: updateUserLogon,
            isEnabled: function(){
                return _this.isEnabled;
            }
        };

       

        /**
         * @ngdoc method
         * @name sendSMS
         * @methodOf  common.service:ItxPhoneSvc
         * @description
         * 
         * Sends SMS to the indicated phone number
         * 
         */
        function sendSMS(email, phone) {

            var deferred = $q.defer();

            var action = {
                action: 'user:sendSmsValidation',
                params: {
                    storeId: inditex.iStoreId
                },
                data: {
                    email: email,
                    phone: {
                        countryCode: inditex.iStoreJSON.details.phoneCountryCode,
                        subscriberNumber: phone,
                    },
                    functionality: 'PHONE_VALIDATION',
                    type: '1',
                }
            };

            joyr.rest.xRestExecute([action])
                .done(function(response) {
                    deferred.resolve(response);
                })
                .Catch(function(error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }


        /**
         * @ngdoc method
         * @name updateUserPhone
         * @methodOf  common.service:ItxPhoneSvc
         * @description
         * 
         * Updates the user's phone associated
         * 
         */
        function updateUserPhone(phone) {

            var deferred = $q.defer();

            var action = {
                action: 'user:updatePhoneValidation',
                params: {
                    storeId: inditex.iStoreId
                },
                data: {
                      countryCode: inditex.iStoreJSON.details.phoneCountryCode,
                      subscriberNumber: phone,
                }
            };

            joyr.rest.xRestExecute([action])
                .done(function(response) {
                    deferred.resolve(response);
                })
                .Catch(function(error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name validateGuestPhone
         * @methodOf  common.service:ItxPhoneSvc
         * @description
         * 
         * Validates guest user's phone
         * 
         */
        function validateGuestPhone(phone, code) {

            var deferred = $q.defer();

            var action = {
                action: 'user:phoneValidation',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                },
                data: {
                    phone: {
                        countryCode: inditex.iStoreJSON.details.phoneCountryCode,
                        subscriberNumber: phone,
                    },
                    code: code
                }
            };

            joyr.rest.xRestExecute([action])
                .done(function(response) {
                    deferred.resolve(response);
                })
                .Catch(function(error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function updateUserLogon (password, newLogon, code) {
            let deferred = $q.defer();
            let phone = `${inditex.iStoreJSON.details.phoneCountryCode}${newLogon}`;

            let action = {
                action: 'UPDATE_USER_LOGON',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                },
                data: {
                    'password': password,
                    'newLogon': phone,
                    'newLogonConfirm': phone,
                    'code': code
                }
            };

            joyr.rest.xRestExecute([action])
            .done(function(response) {
                deferred.resolve(response);
            })
            .Catch(function(error) {
                deferred.reject(error);
            });
    
            return deferred.promise;
       };

    }

})(window.itxApp);